import React, { useState } from 'react'
import { Post } from '../../web_api/api'
import { Link } from 'react-router-dom'
import Swal from 'sweetalert2'
import { FiChevronRight } from 'react-icons/fi'
import '../../branch/branch.css'

export default function TreatmentCreate() {
    const [name, setName] = useState('')
    const [title, setTitle] = useState('')
    const [description, setDescription] = useState('')
    const [image, setImage] = useState([])
    const [type, setType] = useState('')
    const [addSection, setAddSection] = useState([])

    const [showNextSection, setShowNextSection] = useState(false)
    const [showNextImage, setShowNextImage] = useState(false)

    //NOTE Input Changes when input values
    const handleInputChange = (event, id, field) => {
        const newData = addSection.map(data => {
            if (data.id === id) {
                return { ...data, [field]: event.target.value }
            }
            return data
        })

        // const imgData = image.map(data => {
        //     if (data.id === id) {
        //         return { ...data, [field]: event.target.files[0] }
        //     }
        //     return data
        // })
        console.log(newData, 'new')
        setAddSection(newData)
        // setImage(imgData)
    }



    const AddSection = () => {

        setAddSection([
            ...addSection,
            {
                id: addSection.length + 1,
                title: title,
                description: description
            }
        ])

        // console.log(proMedName, 'pro med')
        setShowNextSection(true)
    }

    //to save image file in array that we click
    const ImageAddSection = (e, id) => {
        const file = e.target.files[0]
        if (!file) return
        const preview = URL.createObjectURL(file)

        setImage(prev => {
            const idx = prev.findIndex(i => i.id === id)
            if (idx !== -1) {
                const next = [...prev]
                next[idx] = { id, blog: file, preview }
                return next
            }
            return [...prev, { id, blog: file, preview }]
        })
        setShowNextImage(true)
    }

    const create = async () => {

        const sectionData = JSON.stringify(addSection)
        console.log(image, 'create')
        const formData = new FormData()
        formData.append('type', type)
        formData.append('name', name)
        image.map((item) => (
            formData.append('blog', item.blog)
        ))
        // formData.append('blog', image)
        formData.append('datas', sectionData)
        if (image.length !== addSection.length) {
            Swal.fire({
                title: 'Need Image!',
                text: 'Try again!',
                icon: 'error',
                // showCancelButton: true,

                showConfirmButton: false,
                timer: 2000
            })
        } else {
            const createTreatment = await Post('/blog', formData, { headers: { 'Content-Type': 'multipart/form-data' } })
            // console.log(createTreatment, 'createTreatment')
        }

    }
    return (
        <div className='branch-page'>
            <div className='branch-breadcrumb'>
                <Link to='/treatment-dashboard'>Treatments</Link>
                <FiChevronRight className='separator' size={14} />
                <span className='current'>Create Treatment</span>
            </div>

            <div className='branch-page-title'>Create Treatment</div>
            <div className='branch-page-subtitle'>Add a new treatment option</div>

            <div className='branch-card'>
                <div className='branch-card-body'>
                    <div className='branch-form-grid'>
                        {/* LEFT COLUMN */}
                        <div>
                            <div className='branch-form-section'>
                                <div className='branch-form-section-title'>Basic Information</div>
                                <div className='branch-field'>
                                    <label className='branch-field-label' for='#tn'>Treatment Name</label>
                                    <input type='text' id='tn' placeholder='Teatment Name' className='branch-input' onChange={(e) => setName(e.target.value)} />
                                </div>
                                <div className='branch-field'>
                                    <label className='branch-field-label' for='#tn'>Treatment Type</label>
                                    <select className='branch-select' onChange={(e) => setType(e.target.value)}>
                                        <option hidden>Choose Type ...</option>
                                        <option value='face'>Face & Skin</option>
                                        <option value='body'>Body Contouring </option>
                                        <option value='dental'>Dental Care</option>
                                    </select>
                                </div>
                            </div>
                        </div>

                        {/* RIGHT COLUMN */}
                        <div>
                            <div className='branch-form-section'>
                                <div className='branch-form-section-title'>Treatment Details</div>

                                {showNextSection ? (
                                    <>
                                        {addSection.map((item, index) => (
                                            <div className='branch-card' key={item.id} style={{ marginBottom: 16 }}>
                                                <div className='branch-card-body'>
                                                    <div className='branch-form-section-title'>Tretment Detail Section {index + 1}</div>
                                                    <div className='branch-field'>
                                                        <label className='branch-field-label' for='#tn'>Title </label>
                                                        <input type='text' id='tn' placeholder='Title' className='branch-input' onChange={(e) => handleInputChange(e, item.id, 'title')} />
                                                    </div>
                                                    <div className='branch-field'>
                                                        <label className='branch-field-label' for='#tn' className={(image.length !== addSection.length) ? 'text-red' : ''}>Image </label>
                                                        <input type='file' id='tn' className='branch-input' onChange={(e) => ImageAddSection(e, item.id)} />

                                                        {image.find(i => i.id === item.id)?.preview && (
                                                            <div className='mt-3 mb-2'>
                                                                <img
                                                                    src={image.find(i => i.id === item.id).preview}
                                                                    alt='preview'
                                                                    style={{ width: '100%', maxWidth: '300px', height: '200px', objectFit: 'cover', borderRadius: '8px', border: '1px solid #ddd' }}
                                                                />
                                                            </div>
                                                        )}
                                                    </div>
                                                    <div className='branch-field'>
                                                        <label className='branch-field-label' for='#tn'>Description </label>
                                                        <textarea type='text' id='tn' placeholder='Write description ...' className='branch-input' onChange={(e) => handleInputChange(e, item.id, 'description')} />
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </>
                                ) : (
                                    <div className='branch-form-section-title' style={{ borderBottom: 'none', color: 'var(--branch-text-muted)', marginBottom: 16 }}>No sections added yet</div>
                                )}

                                <button className='branch-btn branch-btn-outline' style={{ marginTop: 8 }} onClick={AddSection}>+ Add Section</button>
                            </div>
                        </div>
                    </div>

                    <div className='branch-form-footer'>
                        <Link to='/treatment-dashboard' className='branch-btn branch-btn-outline'>Cancel</Link>
                        <button className='branch-btn branch-btn-primary' onClick={create}>Create</button>
                    </div>
                </div>
            </div>
        </div>
    )
}
